import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import SearchBar from "../components/SearchBar";
import VehicleModal from "../components/VehicleModal";
import ClientInfo from "../components/ClientInfo";
import VehicleInfo from "../components/VehicleInfo";
import { useVehicle } from "../Hooks/useVehicle";
import PaginatedTableFleetPositions from "./Components/Tables/Customs/positionsAndLocation/PaginatedTableFleetPositions";
import ReportDropDown from "./Components/DropDownButton/ReportDropDown";
import { ToastComponent } from "./Components/ToastComponent";

const initialFilters = {
  plate: "",
  cpfCnpj: "",
  clientName: "",
};

export default function CustomerServicePage() {
  const dispatch = useDispatch();
  dispatch({ type: "title", value: "Localização" });
  const [searchFilters, setSearchFilters] = useState(initialFilters);
  const [fleetActiveTab, setFleetActiveTab] = useState("positions");
  const [toastParams, setToastParams] = useState("");
  const [reportDates, setReportDates] = useState(() => {
    const start = new Date();
    start.setHours(0, 0, 1, 0);
    return { startDate: start, endDate: new Date() };
  });
  const handleDatesChange = useCallback((start, end) => setReportDates({ startDate: start, endDate: end }), []);

  useEffect(() => {
    const contentContainer = document.querySelector(".movyx-content");
    if (!contentContainer) return undefined;

    contentContainer.classList.add("allow-localization-scroll");

    return () => {
      contentContainer.classList.remove("allow-localization-scroll");
    };
  }, []);

  const {
    vehicles,
    selectedVehicle,
    vehicleDetails,
    isModalOpen,
    loadingVehicles,
    loadingDetails,
    error,
    searchVehicles,
    closeVehicleModal,
    selectVehicle,
    setError,
  } = useVehicle();

  useEffect(() => {
    if (!selectedVehicle?.id) return;

    dispatch({
      type: "vehicleSelected",
      value: {
        ...selectedVehicle,
        vehicleId: selectedVehicle.id,
        clientId: selectedVehicle.clientId,
      },
    });

    setFleetActiveTab("positions");
    const start = new Date();
    start.setHours(0, 0, 1, 0);
    setReportDates({ startDate: start, endDate: new Date() });
  }, [dispatch, selectedVehicle]);

  const handleSearchFilterChange = (field, value) => {
    setSearchFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleSearch = async () => {
    await searchVehicles(searchFilters);
  };

  const handleSelectVehicle = async (vehicle) => {
    await selectVehicle(vehicle);
  };

  return (
    <div className="container-fluid py-3">
      <SearchBar
        filters={searchFilters}
        onChange={handleSearchFilterChange}
        onSearch={handleSearch}
        loading={loadingVehicles}
      />

      <VehicleModal
        show={isModalOpen}
        loading={loadingVehicles}
        vehicles={vehicles}
        error={error}
        onClose={closeVehicleModal}
        onSelectVehicle={handleSelectVehicle}
      />

      {error ? (
        <div className="alert alert-danger d-flex justify-content-between align-items-center">
          <span>{error}</span>
          <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => setError("")}>
            Fechar
          </button>
        </div>
      ) : null}

      {!selectedVehicle ? (
        <div className="alert alert-secondary">
          Busque e selecione um veiculo para visualizar os dados de atendimento.
        </div>
      ) : null}

      {loadingDetails ? (
        <div className="card mb-3">
          <div className="card-body d-flex align-items-center gap-2">
            <div className="spinner-border text-primary" role="status" />
            <span>Carregando dados do cliente e veiculo...</span>
          </div>
        </div>
      ) : null}

      {vehicleDetails ? (
        <>
          <div className="alert alert-warning mb-3 fw-semibold" role="alert">
            Dados a serem confirmados antes de passar qualquer informacao
          </div>

          <ClientInfo client={vehicleDetails.client} />

          <VehicleInfo vehicle={vehicleDetails.vehicle} />

          <ToastComponent
            params={toastParams}
            closeToast={() => setToastParams(JSON.stringify({ show: false }))}
          />

          <div className="d-flex justify-content-end mb-2">
            <ReportDropDown
              vehicleId={selectedVehicle?.clientId ?? selectedVehicle?.id}
              startDate={reportDates.startDate}
              endDate={reportDates.endDate}
              onToast={setToastParams}
            />
          </div>

          <PaginatedTableFleetPositions
            onDatesChange={handleDatesChange}
            activeTab={fleetActiveTab}
            selectedVehicle={selectedVehicle}
            useReportService={true}
            diaryPositions={[]}
            mapLoading={false}
            showTopFilters={false}
            showBackButton={false}
            chooseDisplay={(tabName) => setFleetActiveTab(tabName)}
            onlyEvents={false}
            handleShowPositionMap={async () => {}}
            underMaintenace={vehicleDetails.status?.inMaintenance ? "S" : "N"}
            setCommandDates={() => {}}
            columns={[
              "Data/Hora",
              "ST",
              "IG",
              "VE",
              "Endereço",
              "Eventos",
            ]}
            fields={[
              "generationDate",
              "statusDescription",
              "ignition",
              "speed",
              "location",
              "levelEvent",
            ]}
          />
        </>
      ) : null}
    </div>
  );
}
